import { useAtomValue } from 'jotai'
import React from 'react'
import * as R from 'remeda'

import { getDiffKey } from '~/utils'

import { columnsDiffsAtom } from '../atoms'
import { type ColumnsDiff, type DiffColumnKey } from '../utils'

export const useMapDiffColumnKey = () => {
  const columnsDiffs = useAtomValue(columnsDiffsAtom)

  return React.useCallback(
    <T>(
      mapFunc: (diffColumnKey: DiffColumnKey, columnsDiff: ColumnsDiff) => T,
    ) =>
      R.mapToObj(columnsDiffs, (columnsDiff) => {
        const diffColumnKey = getDiffKey(columnsDiff)

        return [diffColumnKey, mapFunc(diffColumnKey, columnsDiff)]
      }),
    [columnsDiffs],
  )
}
